// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 9774 ? "framework" : chunkId) + "-" + {"595":"b9e5783d1832373f38d5","7932":"78aac8f2bbadbebc5231","9774":"0907406ee497f2b60fce"}[chunkId] + ".js";
};